module.exports = __webpack_public_path__ + "img/business-inhalt.63d24a21.png";